import { Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, model, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { provideNativeDateAdapter } from '@angular/material/core';
import { DateRange, MatDatepickerInputEvent, MatDateRangeInput, MatDateRangePicker } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { end } from '@popperjs/core';
import { LegendPosition } from '@swimlane/ngx-charts';
import { filter, finalize } from 'rxjs';
import { ApiService } from 'src/app/services/api/api.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ModalService } from 'src/app/services/modal-service/modal.service';
import { ErrorModalComponent } from 'src/app/shared/modals/error-modal/error-modal.component';


import {
  Chart,
  ChartConfiguration,
  registerables
} from 'chart.js';
import { getGraphTitle } from 'src/app/shared/utils/graph-helpers';
import { convertToNumber } from 'src/app/shared/utils/convertToNumber';



@Component({
  selector: 'app-summary-dashboard',
  standalone: false,
  templateUrl: './performance-report-dashboard.component.html',
  styleUrl: './performance-report-dashboard.component.scss',

})
export class PerformanceReportDashboardComponent implements OnInit {
  @ViewChild('rangeInput') rangeInput!: MatDateRangeInput<Date>;

  activePeriodFilter: string = 'WEEK';
  filterOpen: boolean = false;




  date: any;

  page: number = 0;
  num: number = 1;
  currentPage: number = 1;
  count: number = 0;
  pageSize: number = 10;
  selectedLimit: number = 10;
  legendPosition = LegendPosition;


  rangePickerForm: FormGroup;
  showSearchForm: boolean;
  searchForm: FormGroup;



  constructor(
    private location: Location,
    private apiService: ApiService,
    private authService: AuthService,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private modalService: ModalService
  ) {

  }

  ngOnInit(): void {
    const queryParams = this.route.snapshot.queryParams;
    const { period, startDate, endDate } = queryParams;

    this.searchForm = this.formBuilder.group({
      applicationStatus: [null],
      paymentStatus: [null],
      createdBy: [null],
      zone: [null],
      taxOffice: [null],
      officerName: [null],
      officerIds: [null],
      startDate: [null],
      endDate: [null],
      assessmentCountCondition: [null],
      amount: [null],
      greaterThan: [null],
      lesserThan: [null],
      greaterThanOrEquals: [null],
      lesserThanOrEquals: [null]
    })

    this.rangePickerForm = this.formBuilder.group({
      startDate: null,
      endDate: null,
    })


    const payload: any = { period: period || 'WEEK' };

    if (period === 'DATE_RANGE' && startDate && endDate) {
      payload.startDate = startDate;
      payload.endDate = endDate;

      this.rangePickerForm.patchValue({ startDate: new Date(startDate), endDate: new Date(endDate) })
    }


    this.setActiveFilter(payload);
    this.fetchAssessmentCard();
    this.fetchApprovalRateData()
    this.fetchFulfillmentRateData()
    this.fetchTopPerformingOfficerData()
    this.fetchReportTable(payload)

    this.chart = new Chart("charts", this.config)


    this.getZones();


    this.searchForm.get('zone').valueChanges.subscribe((zoneId) => {
      if (zoneId) this.getOfficers(zoneId)
    })
  }


  zones: any[];
  getZones() {
    this.zones = null

    this.apiService.get('/report/performance/zone').subscribe((res: any) => {
      this.zones = res
    })
  }

  officers: any[];
  getOfficers(zoneId: number) {
    this.officers = null;

    this.apiService.get('/report/performance/zone/officers?zoneId=' + zoneId).subscribe((res: any) => {
      this.officers = res.data;
      this.searchForm.get('officerIds').reset()
    })
  }

  onConditionChange() {
    this.searchForm.patchValue(
      {
        amount: null,
        greaterThan: null,
        lesserThan: null,
        greaterThanOrEquals: null,
        lesserThanOrEquals: null
      }
    )
  }

  chart: any;

  public config: ChartConfiguration = {
    type: 'scatter',

    data: {
      labels: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      datasets: [
        {
          type: 'line',
          label: '',
          data: [0, 0, 0, 0, 0],
          borderColor: '#FF7274', // Line color
          backgroundColor: 'rgba(75, 92, 92, 0.2)', // Fill under line (optional)
          tension: 0.8, // for smooth curves
          borderWidth: 1.5,

          // fill: true
        },
        {
          type: 'bar',
          label: '',
          data: [0, 0, 0, 0, 0],
          barThickness: 50,
          backgroundColor: ["#0AC4B9", "#F0B615", "#C47A0A", "#AAC40A", "#0AC4B9", "#0F2452", "#94054A"],
        }]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,

      animations: {
        tension: {
          duration: 1000,
          easing: 'linear',
          from: 1,
          to: 0,
          loop: false
        }
      },
      plugins: {

        legend: {
          display: false,
          labels: {
            color: 'rgb(255, 99, 132)'
          }
        },
        title: {
          display: false,
          text: 'TRANSACTIONS CHART',
          color: '#000',
          font: {
            size: 20
          }
        }

      },
      scales: {
        x: {
          type: 'category', // 👈 Force category scale to use string labels
          title: {
            display: true,
            font: {
              size: 16,
              weight: 'bold',
              family: 'Arial'
            },
            color: '#333',
            padding: { top: 10 }
          },
          ticks: {
            color: '#007BFF',
            font: {
              size: 14
            }
          },
        },
        y: {
          beginAtZero: true,
          title: {
            display: true,
            font: {
              size: 16,
              weight: 'bold',
              family: 'Arial'
            },
            color: '#00000',
            padding: { top: 10 }// 👈 Your custom X label here
          }, ticks: {
            font: {
              size: 14
            },
            callback: function (value) {
              // Remove .0 and force integer display
              return Number.isInteger(value) ? value : '';
            }
          },

        }
      },
    },

  };


  // Date Range Filter
  maxRangeInDays = 7;

  dateRangeFilter = (date: Date | null): boolean => {
    if (!date) return false;

    const start = this.rangePickerForm?.get('start')?.value;
    if (!start) return true; // No start date yet, allow all dates

    const maxEndDate = new Date(start);
    maxEndDate.setDate(maxEndDate.getDate() + (this.maxRangeInDays - 1));

    return date <= maxEndDate;
  };


  onDateChange(event: any) {
    const start = this.rangePickerForm.value?.startDate;
    const end = this.rangePickerForm.value?.endDate;
    const maxDateRange = 7;


    if (start && end) {
      this.setActiveFilter(
        {
          period: 'DATE_RANGE',
          startDate: this.formatDateToYMD(start),
          endDate: this.formatDateToYMD(end),
        }
      )

    } else {
    }
  }

  toggleShowSearch() {
    this.showSearchForm = !this.showSearchForm;
  }

  closeSearchForm() {
    this.showSearchForm = false;
  }



  toggleFilterOpen() {
    this.filterOpen = !this.filterOpen
  }


  // single: any[] = [
  //   {
  //     "name": "Germany",
  //     "value": 8940000
  //   },
  //   {
  //     "name": "USA",
  //     "value": 5000000
  //   },
  //   {
  //     "name": "France",
  //     "value": 7200000
  //   }
  // ];
  transactionsByStatus: any[] = [
    {
      name: "Approved Transactions",
      series: [
        { name: "Mon", value: 62000000 },
        { name: "Tue", value: 48000000 },
        { name: "Wed", value: 54000000 },
        { name: "Thu", value: 20000000 },
        { name: "Fri", value: 25000000 },
        { name: "Sat", value: 30000000 },
        { name: "Sun", value: 41000000 },
      ],
    },
    {
      name: "Initiations Transactions",
      series: [
        { name: "Mon", value: 15000000 },
        { name: "Tue", value: 32000000 },
        { name: "Wed", value: 44000000 },
        { name: "Thu", value: 30000000 },
        { name: "Fri", value: 32000000 },
        { name: "Sat", value: 27000000 },
        { name: "Sun", value: 35000000 },
      ],
    },
    {
      name: "Failed Transactions",
      series: [
        { name: "Mon", value: 7000000 },
        { name: "Tue", value: 9000000 },
        { name: "Wed", value: 11000000 },
        { name: "Thu", value: 13000000 },
        { name: "Fri", value: 17000000 },
        { name: "Sat", value: 20000000 },
        { name: "Sun", value: 14000000 },
      ],
    },
  ];

  multi: any[] = [
    {
      "name": "Mon",
      "series": [
        {
          "name": "Initiated Transactions",
          "value": 2800000
        },
        {
          "name": "Approved Transactions",
          "value": 2600002
        },
      ]
    },

    {
      "name": "Teu",
      "series": [
        {
          "name": "Initiated Transactions",
          "value": 2800000
        },
        {
          "name": "Approved Transactions",
          "value": 2600002
        },

      ]
    },

    {
      "name": "Wed",
      "series": [
        {
          "name": "Initiated Transactions",
          "value": 5800000
        },
        {
          "name": "Approved Transactions",
          "value": 5000002
        },

      ]
    },

    {
      "name": "Thurs",
      "series": [
        {
          "name": "Initiated Transactions",
          "value": 5500000
        },
        {
          "name": "Approved Transactions",
          "value": 510002
        },

      ]
    },

    {
      "name": "Fri",
      "series": [
        {
          "name": "Initiated Transactions",
          "value": 2800000
        },
        {
          "name": "Approved Transactions",
          "value": 2600002
        },

      ]
    },
    {
      "name": "Sat",
      "series": [
        {
          "name": "Initiated Transactions",
          "value": 4200000
        },
        {
          "name": "Approved Transactions",
          "value": 3000002
        },

      ]
    },

    {
      "name": "Sun",
      "series": [
        {
          "name": "Initiated Transactions",
          "value": 4200000
        },
        {
          "name": "Approved Transactions",
          "value": 3000002
        },

      ]
    },
  ];


  convertPeriodToFrequency(label: string): string {
    switch (label?.toUpperCase()) {
      case 'TODAY':
        return 'DAILY';
      case 'WEEK':
        return 'WEEKLY';
      case 'MONTH':
        return 'MONTHLY';
      case 'YEAR':
        return 'YEARLY';
      case 'DATE_RANGE':
        return 'DATE_RANGE';
      default:
        return 'UNKNOWN'; // or throw an error, or return null/empty string
    }
  }

  view: [number, number] = [900, 400];

  // options
  showXAxis: boolean = true;
  showYAxis: boolean = true;
  gradient: boolean = true;
  showLegend: boolean = true;
  showXAxisLabel: boolean = true;
  showYAxisLabel: boolean = true;



  barChartColorScheme: any = {
    domain: ['#25775C', '#0CA811']
  };










  setActiveFilter(payload: any) {

    const period = payload?.period;

    if (period !== 'DATE_RANGE') {
      this.rangePickerForm.reset();
    }

    this.activePeriodFilter = period;


    this.fetchSummaryBarChartData(payload)


    const queryParams: any = {
      period
    };

    if (payload.startDate) {
      queryParams.startDate = payload.startDate;
    } else {
      queryParams.startDate = null;
    }

    if (payload.endDate) {
      queryParams.endDate = payload.endDate;
    } else {
      queryParams.endDate = null;
    }

    this.router.navigate([], {
      queryParams,
      queryParamsHandling: 'merge'
    });

    this.filterOpen = false;

    this.currentPage = 1;

  }


  formatActiveFilterTitle(filter: any) {
    switch (filter?.toUpperCase()) {

      case 'DATE_RANGE': {
        const startDate = this.rangePickerForm.value?.startDate?.toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric',
          year: 'numeric'
        });;

        const endDate = this.rangePickerForm.value?.endDate?.toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric',
          year: 'numeric'
        });;



        return `${startDate} - ${endDate}`;
      }
      default:
        return 'Date'; // or throw an error, or return null/empty string
    }
  }

  formatSearchFormDateRangeTitle() {


    const startDate = this.searchForm.value?.startDate?.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });;

    const endDate = this.searchForm.value?.endDate?.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });;



    return startDate ? `${startDate} - ${endDate || ''}` : '-- Select Date Range --';


  }

  get startDate() {
    return this.searchForm.get('startDate')!
  }

  get endDate() {
    return this.searchForm.get('endDate')!
  }

  clearDatePickerDate() {
    this.searchForm.get('startDate').reset()
    this.searchForm.get('endDate').reset()

  }

  back() {
    this.router.navigate(['/admin/dashboard'])
  }






  searchedtransactionsNotFound = false;
  errorFetchingTransactionHistory = false;
  isSearching: boolean = false;



  formatDateToYMD(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  assessmentCardData: any;
  errorAssessmentCardData: any;
  fetchAssessmentCard() {
    this.assessmentCardData = null;

    this.apiService.get('/report/performance/total-assessments-summary', {}).subscribe((res: any) => {

      this.assessmentCardData = res



    },
      (error) => {
        this.errorAssessmentCardData = true
      })
  }


  approvalRateData: any;
  errorFetchingApprovalRateData: any;
  fetchApprovalRateData() {
    this.assessmentCardData = null;

    this.apiService.get('/report/performance/approved-assessments-percentage', {}).subscribe((res: any) => {

      this.approvalRateData = res



    },
      (error) => {
        this.errorFetchingApprovalRateData = true
      })
  }

  fulfillmentRateData: any;
  errorFetchingFulfillmentRateData: any;
  fetchFulfillmentRateData() {
    this.fulfillmentRateData = null;

    this.apiService.get('/report/performance/paid-assessments-percentage', {}).subscribe((res: any) => {

      this.fulfillmentRateData = res



    },
      (error) => {
        this.errorFetchingFulfillmentRateData = true
      })
  }

  topPerformingOfficerCardData: any = { officerName: null, totalAssessmentAmount: null, totalAssessmentCount: null };
  errorTopPerformingOfficerCardData: any;
  fetchTopPerformingOfficerData() {

    this.apiService.get('/report/performance/top-officer-assessments-amount', {}).subscribe((res: any) => {

      this.topPerformingOfficerCardData
        .officerName = res.officerName.toLowerCase()
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')


      this.topPerformingOfficerCardData
        .totalAssessmentAmount = res.totalAssessmentAmount


    },
      (error) => {
        this.errorTopPerformingOfficerCardData = true
      })


    this.apiService.get('/report/performance/top-officer-assessments-count', {}).subscribe((res: any) => {

      this.topPerformingOfficerCardData
        .officerName = res.officerName.toLowerCase()
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')

      this.topPerformingOfficerCardData.totalAssessmentCount = res.totalAssessmentCount

    },
      (error) => {
        this.errorTopPerformingOfficerCardData = true
      })
  }




  barChartData: any;
  errorFetchingSummaryChartData: any;

  transformToBarChartData(data: {
    approved: { period: string, totalAmount: number }[],
    initiated: { period: string, totalAmount: number }[],
    failed?: { period: string, totalAmount: number }[] // optional
  }) {
    // Get unique periods from any category (assuming all categories share same periods)
    const periods = Array.from(new Set([
      ...data.approved.map(d => d.period),
      ...data.initiated.map(d => d.period),
      ...(data.failed?.map(d => d.period) ?? [])
    ]));

    return periods.map(period => ({
      name: period,
      series: [
        {
          name: "Initiated Transactions",
          value: data.initiated.find(d => d.period === period)?.totalAmount || 0
        },
        {
          name: "Approved Transactions",
          value: data.approved.find(d => d.period === period)?.totalAmount || 0
        },
        // Optional: include failed
        // {
        //   name: "Failed Transactions",
        //   value: data.failed?.find(d => d.period === period)?.totalAmount || 0
        // }
      ]
    }));
  }




  fetchSummaryBarChartData(payload: any) {
    let filter = {};

    const dateRangeValues = this.rangePickerForm.value;

    switch (payload.period) {
      case 'WEEK':
        filter = { thisWeek: true }
        break;
      case 'MONTH':
        filter = { thisMonth: true }
        break;
      case 'YEAR':
        filter = { thisYear: true }
        break;
      case 'DATE_RANGE':
        filter = { startDate: this.formatDateToYMD(dateRangeValues.startDate), endDate: this.formatDateToYMD(dateRangeValues.endDate) }
    }


    this.apiService.post('/report/performance/top-15-officer-assessments-count', filter).subscribe((res: any) => {
      const data = res;

      this.config.data.labels = data.map(item => item.officerName);
      this.config.data.datasets[0].data = data.map(item => item.totalAssessmentCount);
      this.config.data.datasets[1].data = data.map(item => item.totalAssessmentCount);

      this.chart.update();


      this.barChartData = data


    },
      (error) => {
        this.errorFetchingSummaryChartData = true
      })
  }




  // Transactions

  transactions: any[];


  updateLimit() {
    this.currentPage = 1;

    this.page = 0;

    this.callDb()
  }

  onPageChange(event: any) {
    this.currentPage = event;
    this.page = event - 1;

    this.callDb()
  }

  clearSearchFilters() {
    this.searchForm.reset();
    this.showSearchForm = false;
    this.fetchReportTable();
  }

  callDb() {
    const activePeriodFilter = this.activePeriodFilter
    const payload: any = { period: this.activePeriodFilter };
    const rangeFormValues = this.rangePickerForm.value;


    if (activePeriodFilter === 'DATE_RANGE' && rangeFormValues.startDate && rangeFormValues.rangeFormValuesendDate) {
      payload.startDate = rangeFormValues.startDate;
      payload.endDate = rangeFormValues.endDate;
    }

    this.fetchReportTable(payload);
  }


  get appliedFilterCount(): number {
    const formValue = this.searchForm.value;
    const condition = formValue.assessmentCountCondition;

    if (condition) {
      switch (condition) {
        case 'Equals To':
          return formValue.amount ? 1 : 0;
        case 'Greater Than':
          return formValue.greaterThan ? 1 : 0;
        case 'Lesser Than':
          return formValue.lesserThan ? 1 : 0;
        case 'Between':
          let count = 0;
          if (formValue.greaterThanOrEquals) count++;
          if (formValue.lesserThanOrEquals) count++;
          return count;
      }

      return 0; // fallback
    }

    // Count all non-empty fields except `assessmentCountCondition`, 
    // and count startDate + endDate as one if either is set
    let count = 0;
    const keys = Object.keys(formValue);

    let hasDateRange = false;

    for (const key of keys) {
      const value = formValue[key];
      if (key === 'assessmentCountCondition') continue;

      if ((key === 'startDate' || key === 'endDate') && value) {
        hasDateRange = true;
        continue; // skip counting here, we’ll count once after loop
      }

      if (value !== null && value !== '') {
        count++;
      }
    }

    if (hasDateRange) count++;

    return count;
  }



  fetchReportTable(payload?: any) {
    this.transactions = null;
    this.searchedtransactionsNotFound = false;
    this.errorFetchingTransactionHistory = false;
    this.isSearching = true;
    this.showSearchForm = false;
    this.searchForm.markAsPristine()

    this.num = this.page * this.selectedLimit;

    this.pageSize = this.selectedLimit;

    const formValues = this.searchForm?.value;


    const formData: any = {
      offset: Number(this.num),
      limit: Number(this.selectedLimit),
      ...(formValues.startDate && { startDate: this.formatDateToYMD(formValues.startDate) }),
      ...(formValues.endDate && { endDate: this.formatDateToYMD(formValues.endDate) }),
      ...(formValues.amount && { amount: convertToNumber(formValues.amount) }),
      ...(formValues.zone && { zone: formValues.zone }),
      ...(formValues.officerName && { officerName: formValues.officerName.trim() }),
      ...(formValues.officerIds && formValues.officerIds?.length > 0 && { officersIds: formValues.officerIds }),
      ...(formValues.greaterThan && { greaterThan: convertToNumber(formValues.greaterThan) }),
      ...(formValues.lesserThan && { lesserThan: convertToNumber(formValues.lesserThan) }),
      ...(formValues.greaterThanOrEquals && { greaterThanOrEquals: convertToNumber(formValues.greaterThanOrEquals) }),
      ...(formValues.lesserThanOrEquals && { lesserThanOrEquals: convertToNumber(formValues.lesserThanOrEquals) }),
    }



    this.apiService
      .post(`/report/performance/table`, formData)
      .pipe(
        finalize(() => {
          this.isSearching = false;
        })
      )
      .subscribe(
        (response) => {
          this.transactions = response.data;

          this.count = response.total;

          this.searchedtransactionsNotFound = response?.data?.length <= 0;
        },
        (error) => {
          this.modalService.openErrorModal(error?.message);
          this.errorFetchingTransactionHistory = true;
        }
      );
  }


  dropdownOpen: boolean;

  attemptExport(event: MouseEvent) {
    this.showSearchForm = false;
  }


  isExportingExcel: boolean;
  isExportingPdf: boolean;
  isExportingCsv: boolean;
  errorExportingExcel: boolean;
  errorExportingPdf: boolean;
  errorExportingCsv: boolean;
  exportExcel() {
    this.isExportingExcel = true;

    this.apiService
      .excelPost('/report/performance/download/excel', this.transactions)
      .pipe(
        finalize(() => {
          this.isExportingExcel = false;
        })
      )
      .subscribe(
        (response: Blob) => {
          const blob = new Blob([response], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          const url = window.URL.createObjectURL(blob);
          const downloadLink = document.createElement("a");
          downloadLink.href = url;
          downloadLink.download = "performance_report.xlsx";
          downloadLink.click();
          downloadLink.remove();

          window.URL.revokeObjectURL(url);
        },
        (error) => {
          this.modalService.openErrorModal('Error downloading performance report');
          this.errorExportingExcel = true;
        }
      );
  }

  exportPdf() {
    this.isExportingPdf = true;


    this.apiService
      .excelPost('/report/performance/download/pdf', this.transactions)
      .pipe(
        finalize(() => {
          this.isExportingPdf = false;
        })
      )
      .subscribe(
        (response: Blob) => {
          const blob = new Blob([response], { type: "application/pdf" });
          const blobUrl = window.URL.createObjectURL(blob);
          const file = new Blob([response], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          const downloadLink = document.createElement("a");
          downloadLink.href = blobUrl;
          downloadLink.target = "_blank";
          downloadLink.download = "performance_report.pdf";
          downloadLink.click();
        },
        (error) => {
          this.modalService.openErrorModal('Error downloading performance report');
          this.errorExportingExcel = true;
        }
      );
  }

  exportCsv() {
    this.isExportingCsv = true;


    this.apiService
      .excelPost('/report/performance/download/csv', this.transactions)
      .pipe(
        finalize(() => {
          this.isExportingCsv = false;
        })
      )
      .subscribe(
        (response: Blob) => {
          const blob = new Blob([response], { type: "text/csv;charset=utf-8" });


          const url = window.URL.createObjectURL(blob);
          const downloadLink = document.createElement("a");
          downloadLink.href = url;
          downloadLink.download = "performance_report.csv";
          downloadLink.click();
          downloadLink.remove();

          window.URL.revokeObjectURL(url);
        },
        (error) => {
          this.modalService.openErrorModal('Error downloading performance report');
          this.errorExportingCsv = true;
        }
      );
  }



  getPercentageColor(percentage: number): string {
    switch (true) {
      case percentage > 75:
        return '#43A047'; // Green
      case percentage >= 50:
        return '#F9A825'; // Amber
      default:
        return '#E53935'; // Red
    }
  }




}
